import { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";

// utils
import get from "lodash/get";
import set from "lodash/set";
import { mergeDefaultConfig } from "@features/sypi/actions";
import IconRefresh from "@assets/icons/IconRefresh";
import cloneDeep from "lodash/cloneDeep";
// components
import InputField from "@components/ui/InputField";

const styles = {
  styleIconContainer: "inline-block h-[18px] ml-[7px]",
};

const ColorPickerWidget = ({ value, onChange, id, onBlur }) => {
  const sypiNewView = useSelector((state) => state.sypiNewView);
  const schemaAllView = useSelector((state) => state.schemaAllView);
  const { defaultConfig, fieldVisibility } = sypiNewView
    ? sypiNewView
    : schemaAllView;
  const formData = sypiNewView
    ? sypiNewView.sypiConfig
    : schemaAllView.schemaManagementConfig;

  const path = id
    .split(sypiNewView ? "_" : ".")
    .slice(1)
    .join(".");
  const defaultVal = get(defaultConfig, path);
  const sypiConfigCopy = JSON.parse(JSON.stringify(formData));
  // const returnNewConfig = () => set(sypiConfigCopy, path, defaultVal)
  const returnNewConfig = () =>
    formData ? set(cloneDeep(formData), path, defaultVal) : cloneDeep(formData);
  const [inputVal, setInputVal] = useState(value);
  const pulledDiff = get(fieldVisibility, path);
  const [visible, setVisibility] = useState(pulledDiff || !inputVal);
  const dispatch = useDispatch();

  useEffect(() => {
    function syncStateValue() {
      if (value !== inputVal) {
        setInputVal(value);
      }
    }
    syncStateValue();
  }, [value, inputVal]);

  return (
    <>
      <div
        key={`${id}-container`}
        className={`style-icon-container ${styles.styleIconContainer}`}
      >
        {defaultVal !== inputVal && (
          <IconRefresh
            onClick={() => {
              let newConfig = returnNewConfig();
              onChange(defaultVal);
              setInputVal(defaultVal);
              dispatch(mergeDefaultConfig(newConfig));
            }}
          />
        )}
      </div>
      <InputField
        containerWidth="w-[17rem]"
        containerHeight="h-11"
        className={
          "my-[-0.5rem] mx-[-1rem] border-2 border-solid border-transparent"
        }
        defaultContainerStyle={false}
        customId={id}
        onBlurCallback={onBlur}
        onColorCloseCallback={onBlur}
        inputName={id.substring(id.lastIndexOf("_") + 1, id.length)}
        inputValue={inputVal}
        onChangeCallback={(val) => {
          setInputVal(val);
          onChange(val);
        }}
        showColorSwab
        customInputStyle={{ container: "!min-w-[86%]" }}
      />
      <div></div>
    </>
  );
};

export default ColorPickerWidget;
